/**
 * This is the login page and is accessed by going to "/user/login".
 *
 * The page displays a form for the user to provide email and password and on submit will make a call to log
 * the user in.
 */
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { useIntl } from 'react-intl';
import LoginForm from '~/jobiqo/components/User/Login/components/Form';
import { AppContext } from '~/jobiqo/context/app';
import { DIMENSIONS, EVENTS } from '~/jobiqo/lib/analytics';
import { AppContextInterface } from '~/jobiqo/models/app';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';
import { getFrontendAssets } from '~/jobiqo/utils/getFrontend';
import { FormWithImage } from '~/vcl/organisms/01-form/02-withImage';
import { useLoginMessages } from './hooks/useLoginMessages';
import {
  appendQueryParamsToRedirectUrl,
  sanitizeRedirectUrl,
} from '~/jobiqo/lib/redirect';
import UserLoginFormWithImageImageSlot from '~/jobiqo/components/Slots/UserLoginFormWithImageImageSlot';

export function Login() {
  const intl = useIntl();
  useLoginMessages();
  const router = useRouter();
  const { locale }: AppContextInterface = useContext(AppContext);
  const frontendConfig = useFrontendConfig();

  return (
    <main>
      <FormWithImage
        image={getFrontendAssets(frontendConfig).loginImage}
        title={intl.formatMessage({
          id: 'login_image_title',
          defaultMessage: 'Jobiqo login',
        })}
        alt={intl.formatMessage({
          id: 'login_image_alt',
          defaultMessage: 'login banner',
        })}
        slot={<UserLoginFormWithImageImageSlot />}
      >
        <LoginForm
          onLoginSuccess={() => {
            const multipleLanguages =
              router.locales && router.locales?.length > 1;
            // At this moment we don't have user informations.
            // Dashboard component will use dispatch flag from query string to dispatch GA event.
            const destination = router.query?.destination
              ? appendQueryParamsToRedirectUrl(
                  sanitizeRedirectUrl(
                    String(router.query.destination),
                    `${router.basePath}/dashboard`,
                  ),
                  router.query,
                )
              : `${router.basePath}/dashboard`;
            const separator = destination.indexOf('?') > 0 ? '&' : '?';
            window.location.href = `${
              multipleLanguages ? `/${locale}` : ''
            }${destination}${separator}dispatch=${EVENTS.LOGIN.key}&${
              DIMENSIONS.signup_method
            }=email`;
          }}
        />
      </FormWithImage>
    </main>
  );
}
export default Login;
